<h3 class="h2" *ngIf="hasHeading">{{data.header}}</h3>
<img [appLazyload]="data.photo | purify:resourceUrlContext" alt="">
<p [innerHTML]="data.paragraph | purify "></p>
